export const getSectionAndQuestionLabel = (
  type: string,
  qstId: number,
  totalQuestions: number
) => {
  let sectionLabel = "";
  let questionLabel = "";

  if (type === "GENERAL1") {
    if (qstId === 0) {
      sectionLabel = "0 of 5";
      questionLabel = "0 of 55";
    } else if (qstId === 1) {
      sectionLabel = "1 of 5";
      questionLabel = "1 of 1";
    } else if (qstId <= 13) {
      sectionLabel = "2 of 5";
      questionLabel = `${qstId - 1} of 12`;
    } else if (qstId <= 25) {
      sectionLabel = "3 of 5";
      questionLabel = `${qstId - 13} of 12`;
    } else if (qstId <= 40) {
      sectionLabel = "4 of 5";
      questionLabel = `${qstId - 25} of 15`;
    } else {
      sectionLabel = "5 of 5";
      questionLabel = `${qstId - 40} of 15`;
    }
  } else if (type === "GENERAL2") {
    if (qstId === 1) {
      sectionLabel = "1 of 5";
      questionLabel = "1 of 1";
    } else {
      let q = qstId - 1; // کم‌کردن رایتینگ
      if (q < 0) q = 0;
      const section = Math.ceil(q / 20) + 1;
      const questionInSection = ((q - 1) % 20) + 1;
      sectionLabel = `${section} of 5`;
      questionLabel = `${questionInSection} of 20`;
    }
  } else if (type === "GENERAL") {
    const section = Math.ceil(qstId / 20);
    const questionInSection = ((qstId - 1) % 20) + 1;
    sectionLabel = `${section} of 4`;
    questionLabel = `${questionInSection} of 20`;
  } else {
    sectionLabel = "1 of 1";
    questionLabel = `${qstId} of ${totalQuestions}`;
  }

  return { sectionLabel, questionLabel };
};

